// src/api/giftCards.js
import axios from "axios";
import { API_BASE as SBIN_API_BASE } from "./base";

const API = SBIN_API_BASE;

function authHeaders() {
  const token = null;
  return token
    ? {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      }
    : {
        "Content-Type": "application/json",
      };
}

export async function listGiftCards(params = {}) {
  const res = await axios.get(`${API}/gift-cards`, {
    params,
    headers: authHeaders(),
  });
  return res.data;
}

export async function getGiftCardDetails(code, params = {}) {
  const res = await axios.get(
    `${API}/gift-cards/${encodeURIComponent(code)}`,
    {
      params,
      headers: authHeaders(),
    }
  );
  return res.data;
}

export async function listClientGiftCards(clientId) {
  const res = await axios.get(`${API}/clients/${clientId}/gift-cards`, {
    headers: authHeaders(),
  });
  return res.data;
}

export async function validateGiftCard(code, salonId, ticketId) {
  const params = { code };
  if (salonId) {
    params.salon_id = salonId;
  }
  if (ticketId) {
    params.ticket_id = ticketId;
  }
  const res = await axios.get(`${API}/gift-cards/validate`, {
    params,
    headers: authHeaders(),
  });
  return res.data;
}

export async function checkGiftCardCodeAvailable(code, salonId) {
  const params = { code };
  if (salonId) {
    params.salon_id = salonId;
  }
  const res = await axios.get(`${API}/gift-cards/code-available`, {
    params,
    headers: authHeaders(),
  });
  return res.data;
}

export async function generateGiftCardCode(salonId) {
  const params = {};
  if (salonId) {
    params.salon_id = salonId;
  }
  const res = await axios.get(`${API}/gift-cards/generate-code`, {
    params,
    headers: authHeaders(),
  });
  return res.data;
}
